/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { DeliveryHandoffInstructions } from './DeliveryHandoffInstructions';
import {
    DeliveryHandoffInstructionsFromJSON,
    DeliveryHandoffInstructionsFromJSONTyped,
    DeliveryHandoffInstructionsToJSON,
    DeliveryHandoffInstructionsToJSONTyped,
} from './DeliveryHandoffInstructions';
import type { MenuOrderItem } from './MenuOrderItem';
import {
    MenuOrderItemFromJSON,
    MenuOrderItemFromJSONTyped,
    MenuOrderItemToJSON,
    MenuOrderItemToJSONTyped,
} from './MenuOrderItem';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';
import type { HandoffOptions } from './HandoffOptions';
import {
    HandoffOptionsFromJSON,
    HandoffOptionsFromJSONTyped,
    HandoffOptionsToJSON,
    HandoffOptionsToJSONTyped,
} from './HandoffOptions';
import type { OrderRefund } from './OrderRefund';
import {
    OrderRefundFromJSON,
    OrderRefundFromJSONTyped,
    OrderRefundToJSON,
    OrderRefundToJSONTyped,
} from './OrderRefund';
import type { MenuOrderStatus } from './MenuOrderStatus';
import {
    MenuOrderStatusFromJSON,
    MenuOrderStatusFromJSONTyped,
    MenuOrderStatusToJSON,
    MenuOrderStatusToJSONTyped,
} from './MenuOrderStatus';
import type { MenuOrderDiscount } from './MenuOrderDiscount';
import {
    MenuOrderDiscountFromJSON,
    MenuOrderDiscountFromJSONTyped,
    MenuOrderDiscountToJSON,
    MenuOrderDiscountToJSONTyped,
} from './MenuOrderDiscount';
import type { MenuOrderLog } from './MenuOrderLog';
import {
    MenuOrderLogFromJSON,
    MenuOrderLogFromJSONTyped,
    MenuOrderLogToJSON,
    MenuOrderLogToJSONTyped,
} from './MenuOrderLog';
import type { MenuOrderServiceFee } from './MenuOrderServiceFee';
import {
    MenuOrderServiceFeeFromJSON,
    MenuOrderServiceFeeFromJSONTyped,
    MenuOrderServiceFeeToJSON,
    MenuOrderServiceFeeToJSONTyped,
} from './MenuOrderServiceFee';
import type { OloError } from './OloError';
import {
    OloErrorFromJSON,
    OloErrorFromJSONTyped,
    OloErrorToJSON,
    OloErrorToJSONTyped,
} from './OloError';

/**
 * Represents a single menu order in the system.
 * @export
 * @interface MenuOrder
 */
export interface MenuOrder {
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    business: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    subtotal: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    stripeTotal: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    stripeFee?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    marketplaceWithholding?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    tax: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    deliveryCharge: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    tipMerchant?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    tipDelivery?: number;
    /**
     * 
     * @type {Array<MenuOrderDiscount>}
     * @memberof MenuOrder
     */
    discounts?: Array<MenuOrderDiscount>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MenuOrder
     */
    discountCodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    paymentIntentId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    paymentTransferId?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    fuelTotal: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    fuel?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    onChainFuelX?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MenuOrder
     */
    isMagicWallet?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    transactionHash?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    fuelTransaction?: string;
    /**
     * USD amount of LootShop credit the user elected to apply to this order (payment tender, Devour-funded). Reduces the card charge (stripeTotal), not merchantOwed.
     * @type {number}
     * @memberof MenuOrder
     */
    lootShopCreditApplied?: number;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    lootShopCreditTransaction?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    fuelRewardsIndustry: number;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    fuelRewardsIndustryTransaction?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    fuelRewardsPayment?: number;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    fuelRewardsPaymentTransaction?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    fuelFiatAtOrderTime?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    experienceRewards?: number;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    experienceRewardsTransaction?: string;
    /**
     * 
     * @type {MenuOrderStatus}
     * @memberof MenuOrder
     */
    status?: MenuOrderStatus;
    /**
     * 
     * @type {Array<MenuOrderLog>}
     * @memberof MenuOrder
     */
    log?: Array<MenuOrderLog>;
    /**
     * 
     * @type {Address}
     * @memberof MenuOrder
     */
    address: Address;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    distance?: number;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    merchantNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    deliveryNotes?: string;
    /**
     * 
     * @type {DeliveryHandoffInstructions}
     * @memberof MenuOrder
     */
    deliveryHandoffInstructions?: DeliveryHandoffInstructions;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    scheduledTime?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    readyBy?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    marketplacePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    marketplaceFee?: number;
    /**
     * 
     * @type {Array<MenuOrderServiceFee>}
     * @memberof MenuOrder
     */
    serviceFees?: Array<MenuOrderServiceFee>;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    merchantOwed?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    grandTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    transferAmount?: number;
    /**
     * 
     * @type {HandoffOptions}
     * @memberof MenuOrder
     */
    handoff?: HandoffOptions;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    pickupCode?: string;
    /**
     * 
     * @type {Array<MenuOrderItem>}
     * @memberof MenuOrder
     */
    orderItems: Array<MenuOrderItem>;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    email?: string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof MenuOrder
     */
    phoneNumber?: PhoneNumber;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    cancellationReason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MenuOrder
     */
    stripeCheckout?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MenuOrder
     */
    paidToDevour?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    paymentIntent?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    chowlyId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    deliveryId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    dspId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    discountSelected?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MenuOrder
     */
    discountNullify?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MenuOrder
     */
    callbackComplete?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    coinbaseChargeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MenuOrder
     */
    isCoinbase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MenuOrder
     */
    coinbaseChargeData?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MenuOrder
     */
    exceededSlippage?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    validationErrorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    devourIqNotification?: string;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof MenuOrder
     */
    refunds?: Array<OrderRefund>;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    uberEatsUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    uberEatsAccountID?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    orderUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    oloBasketId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    oloOrderGuid?: string;
    /**
     * 
     * @type {Array<OloError>}
     * @memberof MenuOrder
     */
    oloErrors?: Array<OloError>;
    /**
     * 
     * @type {object}
     * @memberof MenuOrder
     */
    shippingAddress?: object;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    externalOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    trackingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrder
     */
    trackingCarrier?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrder
     */
    estimatedDelivery?: number;
}



/**
 * Check if a given object implements the MenuOrder interface.
 */
export function instanceOfMenuOrder(value: object): value is MenuOrder {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('customer' in value) || value['customer'] === undefined) return false;
    if (!('business' in value) || value['business'] === undefined) return false;
    if (!('subtotal' in value) || value['subtotal'] === undefined) return false;
    if (!('stripeTotal' in value) || value['stripeTotal'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('deliveryCharge' in value) || value['deliveryCharge'] === undefined) return false;
    if (!('fuelTotal' in value) || value['fuelTotal'] === undefined) return false;
    if (!('fuelRewardsIndustry' in value) || value['fuelRewardsIndustry'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('orderItems' in value) || value['orderItems'] === undefined) return false;
    return true;
}

export function MenuOrderFromJSON(json: any): MenuOrder {
    return MenuOrderFromJSONTyped(json, false);
}

export function MenuOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'currency': json['currency'],
        'customer': json['customer'],
        'business': json['business'],
        'subtotal': json['subtotal'],
        'stripeTotal': json['stripeTotal'],
        'stripeFee': json['stripeFee'] == null ? undefined : json['stripeFee'],
        'marketplaceWithholding': json['marketplaceWithholding'] == null ? undefined : json['marketplaceWithholding'],
        'tax': json['tax'],
        'deliveryCharge': json['deliveryCharge'],
        'tipMerchant': json['tipMerchant'] == null ? undefined : json['tipMerchant'],
        'tipDelivery': json['tipDelivery'] == null ? undefined : json['tipDelivery'],
        'discounts': json['discounts'] == null ? undefined : ((json['discounts'] as Array<any>).map(MenuOrderDiscountFromJSON)),
        'discountCodes': json['discountCodes'] == null ? undefined : json['discountCodes'],
        'paymentMethodId': json['paymentMethodId'] == null ? undefined : json['paymentMethodId'],
        'paymentIntentId': json['paymentIntentId'] == null ? undefined : json['paymentIntentId'],
        'paymentTransferId': json['paymentTransferId'] == null ? undefined : json['paymentTransferId'],
        'fuelTotal': json['fuelTotal'],
        'fuel': json['fuel'] == null ? undefined : json['fuel'],
        'onChainFuelX': json['onChainFuelX'] == null ? undefined : json['onChainFuelX'],
        'isMagicWallet': json['isMagicWallet'] == null ? undefined : json['isMagicWallet'],
        'transactionHash': json['transactionHash'] == null ? undefined : json['transactionHash'],
        'fuelTransaction': json['fuelTransaction'] == null ? undefined : json['fuelTransaction'],
        'lootShopCreditApplied': json['lootShopCreditApplied'] == null ? undefined : json['lootShopCreditApplied'],
        'lootShopCreditTransaction': json['lootShopCreditTransaction'] == null ? undefined : json['lootShopCreditTransaction'],
        'fuelRewardsIndustry': json['fuelRewardsIndustry'],
        'fuelRewardsIndustryTransaction': json['fuelRewardsIndustryTransaction'] == null ? undefined : json['fuelRewardsIndustryTransaction'],
        'fuelRewardsPayment': json['fuelRewardsPayment'] == null ? undefined : json['fuelRewardsPayment'],
        'fuelRewardsPaymentTransaction': json['fuelRewardsPaymentTransaction'] == null ? undefined : json['fuelRewardsPaymentTransaction'],
        'fuelFiatAtOrderTime': json['fuelFiatAtOrderTime'] == null ? undefined : json['fuelFiatAtOrderTime'],
        'experienceRewards': json['experienceRewards'] == null ? undefined : json['experienceRewards'],
        'experienceRewardsTransaction': json['experienceRewardsTransaction'] == null ? undefined : json['experienceRewardsTransaction'],
        'status': json['status'] == null ? undefined : MenuOrderStatusFromJSON(json['status']),
        'log': json['log'] == null ? undefined : ((json['log'] as Array<any>).map(MenuOrderLogFromJSON)),
        'address': AddressFromJSON(json['address']),
        'distance': json['distance'] == null ? undefined : json['distance'],
        'merchantNotes': json['merchantNotes'] == null ? undefined : json['merchantNotes'],
        'deliveryNotes': json['deliveryNotes'] == null ? undefined : json['deliveryNotes'],
        'deliveryHandoffInstructions': json['deliveryHandoffInstructions'] == null ? undefined : DeliveryHandoffInstructionsFromJSON(json['deliveryHandoffInstructions']),
        'scheduledTime': json['scheduledTime'] == null ? undefined : json['scheduledTime'],
        'readyBy': json['readyBy'] == null ? undefined : json['readyBy'],
        'marketplacePercentage': json['marketplacePercentage'] == null ? undefined : json['marketplacePercentage'],
        'marketplaceFee': json['marketplaceFee'] == null ? undefined : json['marketplaceFee'],
        'serviceFees': json['serviceFees'] == null ? undefined : ((json['serviceFees'] as Array<any>).map(MenuOrderServiceFeeFromJSON)),
        'merchantOwed': json['merchantOwed'] == null ? undefined : json['merchantOwed'],
        'grandTotal': json['grandTotal'] == null ? undefined : json['grandTotal'],
        'transferAmount': json['transferAmount'] == null ? undefined : json['transferAmount'],
        'handoff': json['handoff'] == null ? undefined : HandoffOptionsFromJSON(json['handoff']),
        'pickupCode': json['pickupCode'] == null ? undefined : json['pickupCode'],
        'orderItems': ((json['orderItems'] as Array<any>).map(MenuOrderItemFromJSON)),
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberFromJSON(json['phoneNumber']),
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'cancellationReason': json['cancellationReason'] == null ? undefined : json['cancellationReason'],
        'stripeCheckout': json['stripeCheckout'] == null ? undefined : json['stripeCheckout'],
        'paidToDevour': json['paidToDevour'] == null ? undefined : json['paidToDevour'],
        'paymentIntent': json['paymentIntent'] == null ? undefined : json['paymentIntent'],
        'chowlyId': json['chowlyId'] == null ? undefined : json['chowlyId'],
        'deliveryId': json['deliveryId'] == null ? undefined : json['deliveryId'],
        'dspId': json['dspId'] == null ? undefined : json['dspId'],
        'discountSelected': json['discountSelected'] == null ? undefined : json['discountSelected'],
        'discountNullify': json['discountNullify'] == null ? undefined : json['discountNullify'],
        'callbackComplete': json['callbackComplete'] == null ? undefined : json['callbackComplete'],
        'coinbaseChargeId': json['coinbaseChargeId'] == null ? undefined : json['coinbaseChargeId'],
        'isCoinbase': json['isCoinbase'] == null ? undefined : json['isCoinbase'],
        'coinbaseChargeData': json['coinbaseChargeData'] == null ? undefined : json['coinbaseChargeData'],
        'exceededSlippage': json['exceededSlippage'] == null ? undefined : json['exceededSlippage'],
        'validationErrorMessage': json['validationErrorMessage'] == null ? undefined : json['validationErrorMessage'],
        'devourIqNotification': json['devourIqNotification'] == null ? undefined : json['devourIqNotification'],
        'refunds': json['refunds'] == null ? undefined : ((json['refunds'] as Array<any>).map(OrderRefundFromJSON)),
        'uberEatsUuid': json['uberEatsUuid'] == null ? undefined : json['uberEatsUuid'],
        'uberEatsAccountID': json['uberEatsAccountID'] == null ? undefined : json['uberEatsAccountID'],
        'orderUuid': json['orderUuid'] == null ? undefined : json['orderUuid'],
        'oloBasketId': json['oloBasketId'] == null ? undefined : json['oloBasketId'],
        'oloOrderGuid': json['oloOrderGuid'] == null ? undefined : json['oloOrderGuid'],
        'oloErrors': json['oloErrors'] == null ? undefined : ((json['oloErrors'] as Array<any>).map(OloErrorFromJSON)),
        'shippingAddress': json['shippingAddress'] == null ? undefined : json['shippingAddress'],
        'externalOrderId': json['externalOrderId'] == null ? undefined : json['externalOrderId'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'trackingCarrier': json['trackingCarrier'] == null ? undefined : json['trackingCarrier'],
        'estimatedDelivery': json['estimatedDelivery'] == null ? undefined : json['estimatedDelivery'],
    };
}

export function MenuOrderToJSON(json: any): MenuOrder {
    return MenuOrderToJSONTyped(json, false);
}

export function MenuOrderToJSONTyped(value?: MenuOrder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'currency': value['currency'],
        'customer': value['customer'],
        'business': value['business'],
        'subtotal': value['subtotal'],
        'stripeTotal': value['stripeTotal'],
        'stripeFee': value['stripeFee'],
        'marketplaceWithholding': value['marketplaceWithholding'],
        'tax': value['tax'],
        'deliveryCharge': value['deliveryCharge'],
        'tipMerchant': value['tipMerchant'],
        'tipDelivery': value['tipDelivery'],
        'discounts': value['discounts'] == null ? undefined : ((value['discounts'] as Array<any>).map(MenuOrderDiscountToJSON)),
        'discountCodes': value['discountCodes'],
        'paymentMethodId': value['paymentMethodId'],
        'paymentIntentId': value['paymentIntentId'],
        'paymentTransferId': value['paymentTransferId'],
        'fuelTotal': value['fuelTotal'],
        'fuel': value['fuel'],
        'onChainFuelX': value['onChainFuelX'],
        'isMagicWallet': value['isMagicWallet'],
        'transactionHash': value['transactionHash'],
        'fuelTransaction': value['fuelTransaction'],
        'lootShopCreditApplied': value['lootShopCreditApplied'],
        'lootShopCreditTransaction': value['lootShopCreditTransaction'],
        'fuelRewardsIndustry': value['fuelRewardsIndustry'],
        'fuelRewardsIndustryTransaction': value['fuelRewardsIndustryTransaction'],
        'fuelRewardsPayment': value['fuelRewardsPayment'],
        'fuelRewardsPaymentTransaction': value['fuelRewardsPaymentTransaction'],
        'fuelFiatAtOrderTime': value['fuelFiatAtOrderTime'],
        'experienceRewards': value['experienceRewards'],
        'experienceRewardsTransaction': value['experienceRewardsTransaction'],
        'status': MenuOrderStatusToJSON(value['status']),
        'log': value['log'] == null ? undefined : ((value['log'] as Array<any>).map(MenuOrderLogToJSON)),
        'address': AddressToJSON(value['address']),
        'distance': value['distance'],
        'merchantNotes': value['merchantNotes'],
        'deliveryNotes': value['deliveryNotes'],
        'deliveryHandoffInstructions': DeliveryHandoffInstructionsToJSON(value['deliveryHandoffInstructions']),
        'scheduledTime': value['scheduledTime'],
        'readyBy': value['readyBy'],
        'marketplacePercentage': value['marketplacePercentage'],
        'marketplaceFee': value['marketplaceFee'],
        'serviceFees': value['serviceFees'] == null ? undefined : ((value['serviceFees'] as Array<any>).map(MenuOrderServiceFeeToJSON)),
        'merchantOwed': value['merchantOwed'],
        'grandTotal': value['grandTotal'],
        'transferAmount': value['transferAmount'],
        'handoff': HandoffOptionsToJSON(value['handoff']),
        'pickupCode': value['pickupCode'],
        'orderItems': ((value['orderItems'] as Array<any>).map(MenuOrderItemToJSON)),
        'email': value['email'],
        'phoneNumber': PhoneNumberToJSON(value['phoneNumber']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'errorMessage': value['errorMessage'],
        'cancellationReason': value['cancellationReason'],
        'stripeCheckout': value['stripeCheckout'],
        'paidToDevour': value['paidToDevour'],
        'paymentIntent': value['paymentIntent'],
        'chowlyId': value['chowlyId'],
        'deliveryId': value['deliveryId'],
        'dspId': value['dspId'],
        'discountSelected': value['discountSelected'],
        'discountNullify': value['discountNullify'],
        'callbackComplete': value['callbackComplete'],
        'coinbaseChargeId': value['coinbaseChargeId'],
        'isCoinbase': value['isCoinbase'],
        'coinbaseChargeData': value['coinbaseChargeData'],
        'exceededSlippage': value['exceededSlippage'],
        'validationErrorMessage': value['validationErrorMessage'],
        'devourIqNotification': value['devourIqNotification'],
        'refunds': value['refunds'] == null ? undefined : ((value['refunds'] as Array<any>).map(OrderRefundToJSON)),
        'uberEatsUuid': value['uberEatsUuid'],
        'uberEatsAccountID': value['uberEatsAccountID'],
        'orderUuid': value['orderUuid'],
        'oloBasketId': value['oloBasketId'],
        'oloOrderGuid': value['oloOrderGuid'],
        'oloErrors': value['oloErrors'] == null ? undefined : ((value['oloErrors'] as Array<any>).map(OloErrorToJSON)),
        'shippingAddress': value['shippingAddress'],
        'externalOrderId': value['externalOrderId'],
        'trackingNumber': value['trackingNumber'],
        'trackingCarrier': value['trackingCarrier'],
        'estimatedDelivery': value['estimatedDelivery'],
    };
}

